import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Link,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { StyledTableRow } from "../../../Utils/styledcell";

export default function IncomingInvoicesTable({
  rows,
  isMobile,
  onCreatorAction,
  onClientAction,
  formatAmount,
}) {
  /* -------------------------------------------------- MOBILE  */
  if (isMobile) {
    return (
      <Box sx={{ display: "grid", gap: 2 }}>
        {rows.map((inv) => {
          const isClient = Object.prototype.hasOwnProperty.call(inv, "amount_due");
          const link = isClient
            ? `https://www.useblitz.co/invoicing/${inv.id}`
            : `https://www.useblitz.co/creatorinvoice/${inv.id}`;

          return (
            <Card
              key={inv.id}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                transition: "transform .3s",
                "&:hover": { transform: "translateY(-3px)" },
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="subtitle1" fontWeight={600}>
                    {inv.client_name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {inv.invoice_status}
                  </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary">
                  From&nbsp;@{inv.creator_id || "N/A"} • PO&nbsp;#: {inv.po_number || "N/A"}
                </Typography>

                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                  <Typography variant="body1" fontWeight={500}>
                    {formatAmount(inv.amount)}
                  </Typography>
                  {inv.payout_date && (
                    <Typography variant="body2">
                      {new Date(inv.payout_date).toLocaleDateString()}
                    </Typography>
                  )}
                </Box>

                {inv.notes && (
                  <Typography
                    variant="body2"
                    sx={{ mt: 1, fontStyle: "italic", whiteSpace: "pre-wrap" }}
                  >
                    {inv.notes}
                  </Typography>
                )}

                <Divider sx={{ my: 1 }} />

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Link href={link} target="_blank" underline="hover">
                    View
                  </Link>

                  {inv.invoice_status === "pending" && (
                    isClient ? (
                      <Button size="small" onClick={() => onClientAction(inv.id)}>
                        Approve / Decline
                      </Button>
                    ) : (
                      <Button size="small" onClick={() => onCreatorAction(inv.id)}>
                        Approve / Decline
                      </Button>
                    )
                  )}
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    );
  }

  /* -------------------------------------------------- DESKTOP TABLE */
  return (
    <Table sx={{ minWidth: 700 }} aria-label="incoming invoices table">
      <TableHead>
        <TableRow>
          {[
            "Billed To",
            "Billed From",
            "PO #",
            "Amount",
            "Status",
            "Payout Date",
            "Notes",
            "Invoice",
            "Action",
          ].map((h) => (
            <TableCell key={h} align="center">
              {h}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {rows.map((inv) => {
          const isClient = Object.prototype.hasOwnProperty.call(inv, "amount_due");
          const link = isClient
            ? `https://www.useblitz.co/invoicing/${inv.id}`
            : `https://www.useblitz.co/creatorinvoice/${inv.id}`;

          return (
            <StyledTableRow key={inv.id}>
              <TableCell align="center">{inv.client_name}</TableCell>
              <TableCell align="center">@{inv.creator_id || "N/A"}</TableCell>
              <TableCell align="center">{inv.po_number || "N/A"}</TableCell>
              <TableCell align="center">{formatAmount(inv.amount)}</TableCell>
              <TableCell align="center">{inv.invoice_status}</TableCell>
              <TableCell align="center">
                {inv.payout_date ? new Date(inv.payout_date).toLocaleDateString() : ""}
              </TableCell>
              <TableCell align="center">{inv.notes}</TableCell>
              <TableCell align="center">
                <Link href={link} target="_blank" rel="noopener noreferrer">
                  View
                </Link>
              </TableCell>
              <TableCell align="center">
                {inv.invoice_status === "pending" &&
                  (isClient ? (
                    <Button onClick={() => onClientAction(inv.id)}>Approve / Decline</Button>
                  ) : (
                    <Button onClick={() => onCreatorAction(inv.id)}>Approve / Decline</Button>
                  ))}
              </TableCell>
            </StyledTableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
